import { Input } from "antd";
import { useTranslation } from "react-i18next";
import { renderInputBody } from "../helper";

export default function Text({ data = {}, input = {}, onChange = () => { } }) {
  const { t } = useTranslation();
  const disabled = input.disabled;

  const body = (
    <Input
      disabled={input.disabled}
      size="large"
      value={data[input.key]}
      placeholder={t(input.placeholder || input.label)}
      onChange={(e) => onChange({ [input.key]: e.target.value })} />
  );

  return renderInputBody({ t, disabled, body });
}
